export const getBaseURL = () => {
  const baseUrl = "https://ihub" + process.env.REACT_APP_STAGE + ".rixter.net/" + process.env.REACT_APP_STAGE;
  //const baseUrl = "https://ihubprod.rixter.net/prod";
  return process.env.NODE_ENV === "development" ? "http://localhost:6600" : baseUrl;
};

export const getJiraBaseURL = () => {
  const hostOrigin = window.AP ? window.AP._hostOrigin : "cannot-find-host-url";
  return process.env.NODE_ENV === "development" ? "http://localhost:6600" : hostOrigin;
};

export const getJiraAPIBaseURL = () => {
  const hostOrigin = window.AP ? "https://api.atlassian.com" : "cannot-find-host-url";
  return process.env.NODE_ENV === "development" ? "http://localhost:6600" : hostOrigin;
};

export const getBridgeJiraBaseURL = () => {
  const hostOrigin = window.AP ? window.AP._hostOrigin : "cannot-find-host-url";
  return process.env.NODE_ENV === "development" ? "https://rixterdev.atlassian.net" : hostOrigin;
};

export const getBridgeJiraAPIBaseURL = () => {
  return "https://api.atlassian.com";
};

export const scrollToTop = () => {
  window.AP && window.AP.scrollPosition ? window.AP.scrollPosition.setVerticalPosition(-57) : window.scrollTo(0, 0);
};
export const getLoggedInUser = () => {
  let userId = "unkown";

  if (window.AP && window.AP.user) {
    window.AP.user.getCurrentUser((user) => {
      userId = user.atlassianAccountId;
    });
  }
  return userId;
};
